import React from 'react'


import Banner from './Banner/Banner'
import InfoP from './InfoProducto/InfoP'
import Clientes from './Clientes/Clientes'
import FinalSec from './SmartiaTeam/Finalsec'
import OtrosP from './Carrusel/OtrosP'

export default function Home() {
    return (
        <div>
            <section>
                <Banner/>
                <InfoP/>
                <Clientes/>
                <OtrosP/>
                <FinalSec/>
            </section>
        </div>
    )
}
